import React from 'react'
import type { IMAGE_LOADING, VALID_IMAGE_LAYOUTS } from '../constants'
import { LAYOUT_CONTAIN, LAYOUT_COVER, LAYOUT_RESPONSIVE } from '../constants'

export interface IPictureProps {
  readonly alt: string
  readonly width?: number | string
  readonly height?: number | string
  readonly aspectRatio?: string
  readonly images: string | string[]
  readonly layout?: (typeof VALID_IMAGE_LAYOUTS)[number]
  readonly loading?: (typeof IMAGE_LOADING)[number]
}

export default function Picture({
  alt,
  width,
  height,
  aspectRatio,
  images,
  layout,
  loading,
}: IPictureProps) {
  const imagesArray = Array.isArray(images) ? images : [images]

  const mediaQueries = [
    '(max-width: 767px)',
    '(min-width: 768px) and (max-width: 1023px)',
    '(min-width: 1024px)',
  ]

  for (let i = imagesArray.length; i < mediaQueries.length; i += 1) {
    imagesArray.push(imagesArray.at(-1) as string)
  }

  return (
    <picture>
      {imagesArray.map((img, index) => (
        <source key={img} srcSet={img} media={mediaQueries[index]} />
      ))}
      <img
        {...(loading === 'eager' ? {} : { loading })}
        style={{
          ...(layout === LAYOUT_RESPONSIVE && { width: '100%' }),
          ...(layout === LAYOUT_CONTAIN && { objectFit: 'contain' }),
          ...(layout === LAYOUT_COVER && { objectFit: 'cover' }),
          ...(aspectRatio ? { aspectRatio } : {}),
        }}
        width={width}
        height={height}
        src={imagesArray[0]}
        alt={alt}
      />
    </picture>
  )
}
